var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BrezelApp',[_c('template',{slot:"logo"},[_c('img',{staticStyle:{"width":"100%","max-height":"100px"},attrs:{"src":"/assets/logo.svg","alt":"Logo"}})]),_c('template',{slot:"loginLogo"},[_c('img',{style:({ maxWidth: '100%', margin: '0 auto 26px auto', display: 'block' }),attrs:{"src":"/assets/logo.svg","alt":"logo"}})])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }